import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useAuth } from './lib/auth'
import { PageLoader } from './components/ui'
import { AppShell } from './components/AppShell'
import Login from './routes/Login'
import Join from './routes/Join'
import Campaigns from './routes/Campaigns'
import CampaignDetail from './routes/CampaignDetail'
import CharacterSheet from './routes/CharacterSheet'
import CreateCharacter from './routes/CreateCharacter'
import ImportCharacter from './routes/ImportCharacter'
import Rules from './routes/Rules'

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <PageLoader />
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  return <AppShell>{children}</AppShell>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/join/:code" element={<Join />} />
      <Route path="/" element={<Protected><Campaigns /></Protected>} />
      <Route path="/rules" element={<Protected><Rules /></Protected>} />
      <Route path="/campaigns/:campaignId" element={<Protected><CampaignDetail /></Protected>} />
      <Route path="/campaigns/:campaignId/characters/new" element={<Protected><CreateCharacter /></Protected>} />
      <Route path="/campaigns/:campaignId/characters/import" element={<Protected><ImportCharacter /></Protected>} />
      <Route path="/characters/:characterId" element={<Protected><CharacterSheet /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
